import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export const onDebounce$ = (time) => {
  return new Subject().pipe(
    debounceTime(time)
  )
};
